module.exports = __webpack_public_path__ + "static/drone-bdffcc60df1836623b53db1d704b8581.png";